import { Injectable, signal } from '@angular/core';
import { uid } from '../utils/mock';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  type: ToastType;
  title: string;
  message?: string;
  duration: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toasts = signal<Toast[]>([]);

  private push(type: ToastType, title: string, message?: string, duration = 4200): void {
    const id = uid('toast');
    this.toasts.update((t) => [...t, { id, type, title, message, duration }]);
    setTimeout(() => this.dismiss(id), duration);
  }

  dismiss(id: string): void {
    this.toasts.update((t) => t.filter((toast) => toast.id !== id));
  }

  success(title: string, message?: string): void {
    this.push('success', title, message);
  }

  error(title: string, message?: string): void {
    this.push('error', title, message, 6000);
  }

  warning(title: string, message?: string): void {
    this.push('warning', title, message, 5200);
  }

  info(title: string, message?: string): void {
    this.push('info', title, message);
  }
}
